import React from 'react';
import { connect } from 'react-redux';
import { Intl } from 'components';

const LinkLegal = React.memo( ( {
  href, locale, label, children, ...rest
} ) => {
  const h = {
    es: '',
    en: '',
    ...href,
  };
  return (
    <a
      {...rest}
      href={h[locale.locale]}
      dispatch=""
    >
      {label && (
        <Intl id={label} />
      )}
      {children}
    </a>
  );
} );

const mapStateToProps = ( { settings } ) => ( {
  locale: settings.locale,
} );

export default connect( mapStateToProps, null )( LinkLegal );
